














































import Vue from "vue";
import SummaryPage from "./summery/SummaryPage.vue";
import { state } from "./data/state";
import { computed, onBeforeUnmount, onMounted } from "@vue/composition-api";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import SubjectsBar from "./summery/SubjectsBar.vue";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { POPULATION_TYPE } from "@/common/models";
import { UseModal } from "@/components/root/modal";
import InvestigationModal from "@/views/overview/sources/ms-365-activities/card-items/entity-investigation/InvestigationModal.vue";
export default Vue.extend({
  components: {
    SummaryPage,
    PageWithMainContainer,
    SubjectsBar,
    DropDownSimple,
  },
  setup(_, { root: { $router } }) {
    const {
      from_time_frames,
      selected_from_time_frame,
      set_selected_from_time_frame,
      current_subject,
    } = state;

    const is_current_subject_a_file = computed(() => {
      return (
        current_subject.value &&
        current_subject.value.type == POPULATION_TYPE.FILE
      );
    });

    const show_inv_modal = async () => {
      await UseModal().show(InvestigationModal, true);
    };

    onMounted(() => {
      if (Object.keys(state.subjects.value).length == 0) {
        $router.replace("/");
      }
    });
    onBeforeUnmount(() => {
      state.destroy();
    });
    return {
      from_time_frames,
      selected_from_time_frame,
      set_selected_from_time_frame,
      is_current_subject_a_file,
      show_inv_modal,
    };
  },
});
